<template>
    <div v-if="!isAuth" class="login-btn  d-none d-xl-flex">
        <a :href="$getSubdomainLink('portal', '/login')" class="btn btn-menu-link">Log&nbsp;in</a>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
        };
    },
    methods: {
        logout() {
            this.authStore.logout();
        },
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>